import CitySEOHead from "@/components/feature/CitySEOHead";
import MonroeHeroSection from "./components/HeroSection";
import MonroeStickyNav from "./components/StickyNav";
import MonroeProcessingTimeSection from "./components/ProcessingTimeSection";
import MonroeServicesSection from "./components/ServicesSection";
import MonroeLocalAreaSection from "./components/LocalAreaSection";
import MonroeTravelTimingSection from "./components/TravelTimingSection";
import MonroeDestinationsSection from "./components/DestinationsSection";
import MonroeTestimonialsSection from "./components/TestimonialsSection";
import MonroeAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MonroeComparisonSection from "./components/ComparisonSection";
import MonroeMistakesSection from "./components/MistakesSection";
import MonroeHowItWorksSection from "./components/HowItWorksSection";
import MonroeFAQSection, { faqs } from "./components/FAQSection";
import MonroeHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MonroeFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function MonroePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Monroe"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/monroe"
        title="Emergency Passport Monroe, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Monroe, LA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving healthcare professionals, ULM students, agricultural business travelers, and Northeast Louisiana families."
        geoPlacename="Monroe, Louisiana"
        geoPosition="32.5093;-92.1193"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <MonroeHeroSection />
      <MonroeStickyNav />
      <MonroeProcessingTimeSection />
      <MonroeServicesSection />
      <MonroeLocalAreaSection />
      <MonroeTravelTimingSection />
      <MonroeDestinationsSection />
      <MonroeTestimonialsSection />
      <MonroeAcceptanceFacilitiesSection />
      <MonroeComparisonSection />
      <MonroeMistakesSection />
      <MonroeHowItWorksSection />
      <MonroeFAQSection />
      <MonroeHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/monroe" state="LA" />
      <MonroeFinalCTA />
    </div>
  );
}